import React, { useState, useEffect, useCallback } from 'react';
import { fetchBookings, fetchProfessionals } from '../api';
import './Reports.css';
import ProcedimentosTab from './Tabs/ProcedimentosTab';

function Reports() {
    const [bookings, setBookings] = useState([]);
    const [bookingsLoading, setBookingsLoading] = useState(false);
    const [professionals, setProfessionals] = useState([]);
    const [startDate, setStartDate] = useState(() => {
        const date = new Date();
        date.setDate(date.getDate() - 30); // Last 30 days default
        return date.toISOString().split('T')[0];
    });
    const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);

    const loadBookings = async (queryParams = {}) => {
        try {
            setBookingsLoading(true);
            
            const formattedParams = {
                ...queryParams,
                // Add comissionStatus to use the working GSI path
                comissionStatus: 'unpaid'
            };

            if (queryParams.startDate) {
                formattedParams.startDate = `${queryParams.startDate}`;
                formattedParams.endDate = `${queryParams.endDate}`;
            }

            const bookingsData = await fetchBookings(formattedParams);
            
            // Since we're getting both paid and unpaid, let's make another call for paid commissions
            const paidBookingsData = await fetchBookings({
                ...formattedParams,
                comissionStatus: 'sent'
            });
            
            // Combine both results
            const allBookings = [...bookingsData, ...paidBookingsData];
            setBookings(allBookings);
        } catch (error) {
            console.error('Error fetching bookings:', error);
        } finally {
            setBookingsLoading(false);
        }
    };

    const handleSearch = useCallback(() => {
        if (!startDate || !endDate) {
            alert('Por favor, selecione as datas de início e fim');
            return;
        }

        const queryParams = {
            startDate: `${startDate}`,
            endDate: `${endDate}`
        };

        loadBookings(queryParams);
    }, [startDate, endDate]);

    useEffect(() => {
        fetchProfessionals()
            .then(data => {
                const professionalsList = Object.entries(data.config.profissionais).map(([name, details]) => ({
                    name,
                    ...details
                }));
                setProfessionals(professionalsList);
            })
            .catch(error => console.error('Error fetching professionals:', error));
    }, []);

    useEffect(() => {
        // Load last 30 days of data by default
        handleSearch();
    }, [handleSearch]);

    const handleQuickFilter = (days) => {
        const end = new Date();
        const start = new Date();
        start.setDate(start.getDate() - days);
        
        const startStr = start.toISOString().split('T')[0];
        const endStr = end.toISOString().split('T')[0];
        
        setStartDate(startStr);
        setEndDate(endStr);
        
        loadBookings({
            startDate: `${startStr}`,
            endDate: `${endStr}`
        });
    };

    const groupBookingsByProcedures = () => {
        const groupedProcedures = {};
        
        bookings
            .filter(booking => booking.status === 'Realizado')
            .forEach(booking => {
                if (booking.procedimentosList && booking.procedimentosList.length > 0) {
                    booking.procedimentosList.forEach(procedure => {
                        // Split procedure name on " - " and take first part
                        let procedureName = procedure.nome;
                        if (procedureName && procedureName.includes(' - ')) {
                            procedureName = procedureName.split(' - ')[0];
                        }
                        
                        if (!groupedProcedures[procedureName]) {
                            groupedProcedures[procedureName] = {
                                count: 0,
                                totalValue: 0,
                                bookings: []
                            };
                        }
                        
                        groupedProcedures[procedureName].count += 1;
                        groupedProcedures[procedureName].totalValue += parseFloat(procedure.valor || 0);
                        groupedProcedures[procedureName].bookings.push({
                            ...booking,
                            procedureValue: procedure.valor
                        });
                    });
                }
            });
        
        return groupedProcedures;
    };

    return (
        <div className="reports-container">
            <div className="reports-tabs">
                <button 
                    className="tab-button active"
                >
                    Procedimentos
                </button>
            </div>

            <ProcedimentosTab
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                bookingsLoading={bookingsLoading}
                bookings={bookings}
                handleSearch={handleSearch}
                handleQuickFilter={handleQuickFilter}
                groupBookingsByProcedures={groupBookingsByProcedures}
                setBookings={setBookings}
                professionals={professionals}
            />
        </div>
    );
}

export default Reports;